"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelCheapestRoomForDate = void 0;
const dayjs = require("dayjs");
const getHotelCheapestRoomForDate = (date, pkgs) => {
    // get a list of room prices for all packages
    if (!date) {
        date = dayjs().toISOString();
    }
    const prices = pkgs.map((pkg) => {
        const room_prices = pkg?.room?.prices.find((price) => {
            return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
                dayjs(date).unix() <= dayjs(price.to_date).unix());
        }) || { total: 0 };
        return room_prices?.total / pkg.room?.room_basis;
    });
    // get the lowest price
    const lowest_price = Math.min(...prices);
    return lowest_price;
};
exports.getHotelCheapestRoomForDate = getHotelCheapestRoomForDate;
